<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage {{this.lblHeading}}</b></h5>
    </div>
  </div>
  <hr>
  <div class="row">
    <div *ngIf="isRemove" class="text-danger col-md-12">
      <input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
      <button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
      <button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
    </div>
    <div class="col-md-12" *ngIf="!isRemove">
      <table id="vTypes" border="1" class="table tbl-stl">
        <thead class="thead-inverse tbl-hd-stl hgt-btn">
          <tr  class="hgt-btn">
            <th style= "vertical-align:middle;margin:0px;padding:0px;">
              #
              
            </th>
            <th style="vertical-align:middle;margin:0px;padding:0px;">
              Name
             
            </th>
            <th style="vertical-align:middle;margin:0px;padding:0px;">
              Start
              
            </th>
            <th style="vertical-align:middle;margin:0px;padding:0px;">
              Status
              
            </th>
            <th style="vertical-align:middle;margin:0px;padding:0px;">
              Role
              
            </th>
            <th style="vertical-align:middle;margin:0px;padding:0px;">
              User
            </th>
          
           <!--  <th class="btn-show hgt-btn">
              <a [routerLink]="['/workflow/dashboard/add']" title="" style="width:180px; ">
                <span title="Action" class=" btn-add btn btn-primary btn-sm"><i class="fa fa-plus fa-2x" aria-hidden="true"></i></span>
              </a>
            </th> -->
          </tr>
        </thead>
        <tr style="height: 10px !important;" *ngFor="let vFlow of vFlows   | paginate: { itemsPerPage: 5, currentPage: page }">
          <td>{{vFlow.WorkflowInstanceId}}</td>
          <td>{{vFlow.WorkflowName}}</td>
          <td>{{vFlow.Start}}</td>
          <td>{{vFlow.Status}}</td>
          <td>{{vFlow.Role}}</td>
          <td>{{vFlow.User}}</td>
         <!--  <td class="btn-show">
            <a [routerLink]="['/workflow/dashboard/edit',vFlow.id]"><span title="Edit Workflow" style="margin: 0%" class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a>
            <span title="Delete Workflow" style="margin: 0%" class="btn btn-danger btn-sm" (click)="onConfirm(vFlow)"><i class="fa fa-trash-o fa-fw"></i></span>
          </td> -->
        </tr>
        <tfoot>
          <tr *ngIf="vFlows.length > 4">
            <td colspan="4" class="rm-brd">
              <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No Workflows found.</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

